/*
*mutation事件常量定义
*/
// 全局消息
export const setMessage = 'setMessage'


// WEBPACK FOOTER //
// ./src/store/mutation-types.js